import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './Vitrine/views/Home';
import Bump from './Vitrine/views/Bump';
import NotFound from './Vitrine/views/404';
import Discord from './Vitrine/views/Discord';
import Invite from './Vitrine/views/Invite';

import Dashboard from './Dashboard/views/Home.js'
import Login from './Dashboard/views/Login'

import ChristmasAnimation from './Vitrine/components/Snowfall'; 
import NewYearAnimation from './Vitrine/components/NewYear';

function App() {
  const now = useMemo(() => new Date(), []);
  // const isHelloween = () => { return now.getMonth() === 10 && now.getDate() >= 1; };
  const isChristmas = () => { return now.getMonth() === 11 && now.getDate() >= 1; };
  const isNewyear = () => { return now.getMonth() === 0 && now.getDate() >= 1; };

  const [cookiesAccepted, setCookiesAccepted] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const disableRightClick = useCallback((event) => { event.preventDefault(); }, []);
  const handleKeyDown = useCallback((event) => {if (event.key === 'F12' || (event.ctrlKey && (event.key === 's' || event.key === 'p'))) {console.log('Vous ne possédez pas cette permission.');event.preventDefault();}}, []);
  const handleConsent = (accepted) => {const expirationTime = accepted ? 365 * 24 * 60 * 60 * 1000 : 12 * 60 * 60 * 1000;const expirationDate = new Date(now.getTime() + expirationTime);localStorage.setItem('cookiesAccepted', JSON.stringify({ accepted, expires: expirationDate.toISOString() }));setCookiesAccepted(accepted);};

  useEffect(() => {const cookieData = JSON.parse(localStorage.getItem('cookiesAccepted'));if (cookieData && new Date(cookieData.expires) > now) {setCookiesAccepted(cookieData.accepted);} else {localStorage.removeItem('cookiesAccepted');}setIsLoaded(true);}, [now]);

  useEffect(() => {
    document.addEventListener('contextmenu', disableRightClick);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('contextmenu', disableRightClick);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [disableRightClick, handleKeyDown]);

  return (
    <Router>
      {/* Managing seasonal decorations */}
      {isChristmas() && (<ChristmasAnimation />)}
      {isNewyear() && (<NewYearAnimation />)}
      {/* {isHelloween() && (<ChristmasAnimation />)} */}

      {/* Cookie consent banner */}
      <div className={isLoaded && cookiesAccepted === null ? "cookie-banner" : "cookie-banner hidden"}><img src="https://cdn.jaquesbot.fr/static/website_cookies.svg" draggable="false" alt="❤️ | Cookies, essential to use this site!" className="cookie-image" /><p>This site uses cookies to enhance your experience. <br />Do you accept cookies?</p><button onClick={() => handleConsent(true)} style={{ pointerEvents: 'auto' }}>Accept</button></div>

      <Routes>
        {/* Manage Vitrine route assignments */}
        <Route path="/" element={<Home />} />
        <Route path='/bump' element={<Bump />} />
      
        {/* Discord and Bot Invites */}
        <Route path='/discord' element={<Discord />} />
        <Route path='/invite' element={<Invite />} />

        {/* Manage Dashboard route assignments */}
        <Route path='/dashboard/@home/*' element={<Dashboard />} />
        <Route path='/dashboard/home/*' element={<Dashboard />} />

        <Route path='/dashboard/@login/*' element={<Login />} />
        <Route path='/dashboard/login/*' element={<Login />} />

        {/* Manager for 404 Errors */}
        <Route path="*" element={ window.location.pathname.startsWith('/api/') ? null : <NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
